module.exports = __webpack_public_path__ + "img/trash-can-list.1426148a.svg";